import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/ai/chat/completions', request)
}

export {post}
